import { format } from "date-fns";

export function DisplayTime({ startDate }: { startDate: number }) {
    if (startDate) {
        return <time dateTime={`${startDate}`}>{format(new Date(startDate), "EEE, MMM d, yyyy @ hh:mm a")}</time>;
    }
    return null;
}
